import NfsButton from "../genericComponents/NfsButton/NfsButton";

import CloseIcon from "../../assets/versionControl/close.svg?react";

import "./AcceptVersionAccess.css";
import { acceptVersionAccess, getVersionName, getVersionOwner } from "../../utils/versioningUtils";
import { toast } from "react-toastify";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../Context";
import { useDispatch } from "react-redux";
import { setVersionsSharedWithMe } from "../../store/versionSlice";
import { getSelf } from "../../utils/authenticate";
import { AppConfig } from "../../AppConfig";
import { hasAccessToGroups } from "../../utils/helpers";
import type { VersionInfoExtended } from "@arcgis/core/versionManagement/support/jsonTypes";

interface AcceptVersionAccessProps {
    close: () => void;
    versionInfo: VersionInfoExtended | null;
}

const AcceptVersionAccess = (props: AcceptVersionAccessProps) => {
    const dispatch = useDispatch();

    const [allowedToAcceptEditAccess, setAllowedToAcceptEditAccess] = useState<boolean>(false);

    const userContext = useContext(UserContext);
    const accept = async () => {
        const user = userContext?.user.value;
        if (!user) {
            return;
        }
        const newAccessList = await acceptVersionAccess(props.versionInfo, user);
        dispatch(setVersionsSharedWithMe(newAccessList));
        toast.success("Du aksepterte tilgang til versjonen");
        props.close();
    };

    const decline = () => {
        toast.success("Du avslo tilgang til versjonen");
        props.close();
    };

    // Only allow nautiker to accept edit access
    const canAcceptEditAccess = () => {
        const userSelf = userContext?.userSelf.value;
        if (!userSelf) {
            getSelf().then((res: any) => {
                if (res.data) {
                    userContext?.userSelf.set(res.data);
                }
            });
        } else {
            const nautikerGroupId = AppConfig.GroupAccess.Nautiker;
            const canAccept = hasAccessToGroups(userSelf, [nautikerGroupId]);
            setAllowedToAcceptEditAccess(canAccept);
        }
    }

    const openVersion = () => {
        let versionUrl = globalThis.location.origin;
        const versionName = props.versionInfo?.versionIdentifier.name;
        versionUrl += `/?version=${versionName}`;
        globalThis.location.href = versionUrl;
    };

    useEffect(() => {
        canAcceptEditAccess();
    }, [userContext?.userSelf.value]);

    return (
        <div className="accept-version-access">
            <div className="accept-version-header">
                <h2>Godkjenn tilgang til versjon: {getVersionName(props.versionInfo)}</h2>
                <button className="empty-button" onClick={props.close}>
                    <CloseIcon />
                </button>
            </div>
            <div className="accept-version-content">
                <p>En annen bruker ønsker å gi deg skrive tilgang til en versjon. Vil du godkjenne tilgangen?</p>
                <span>Versjonseier: {getVersionOwner(props.versionInfo)}</span>
                <span>Versjonsnavn: {getVersionName(props.versionInfo)}</span>
                <span>Versjonsbeskrivelse: {props.versionInfo?.description}</span>
            </div>
            {!allowedToAcceptEditAccess &&
                <span>{`Ettersom brukeren din ikke har Nautiker rollen kan du ikke få skrive tilgang til denne versjonen.
                        Du kan åpne versjonen i lesemodus med knappen under`}
                </span>

            }
            <div className="accept-version-footer">
                {allowedToAcceptEditAccess &&
                    <>
                        <NfsButton onClick={accept}>Godkjenn</NfsButton>
                        <NfsButton outlined onClick={decline}>
                            Avslå
                        </NfsButton>
                    </>
                }
                {!allowedToAcceptEditAccess &&
                    <NfsButton onClick={openVersion}>
                        Åpne versjon i lesemodus
                    </NfsButton>
                }
            </div>
        </div>
    );
};

export default AcceptVersionAccess;
